(function () {
  'use strict';

  function slugify(value, index) {
    var base = String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\u4e00-\u9fff\s-]/g, '')
      .replace(/[\s_-]+/g, '-');
    return base || 'article-heading-' + index;
  }

  function parsePullquoteToken(value) {
    var normalized = String(value || '')
      .replace(/[\u200B-\u200D\u2060\uFEFF]/g, '')
      .replace(/\u00A0/g, ' ')
      .trim();
    var match = normalized.match(/^\[\s*pullquote(?:\s*:\s*([a-z0-9][a-z0-9_-]*))?(?:\s*:\s*(mobile))?\s*\]$/i);
    if (!match) return null;
    var handle = (match[1] || '').toLowerCase();
    var mobileOnly = (match[2] || '').toLowerCase() === 'mobile';
    if (handle === 'mobile' && !mobileOnly) {
      handle = '';
      mobileOnly = true;
    }
    return { handle: handle, mobileOnly: mobileOnly };
  }

  function hydratePullquotes(root) {
    var content = root.querySelector('[data-article-v2-content]');
    if (!content) return;

    var templates = Object.create(null);
    Array.prototype.forEach.call(root.querySelectorAll('[data-article-v2-pullquote-template]'), function (template) {
      var handle = (template.getAttribute('data-pullquote-handle') || '').trim().toLowerCase();
      templates[handle] = template;
    });

    Array.prototype.forEach.call(content.querySelectorAll('p'), function (paragraph) {
      var token = parsePullquoteToken(paragraph.textContent);
      if (!token) return;

      var template = templates[token.handle];
      if (template && template.content && template.content.childNodes.length) {
        var pullquoteMarkup = template.content.cloneNode(true);
        if (token.mobileOnly) {
          Array.prototype.forEach.call(pullquoteMarkup.querySelectorAll('.sa-article-v2-pullquote'), function (pullquote) {
            pullquote.classList.add('sa-article-v2-pullquote--mobile-only');
          });
        }
        paragraph.parentNode.insertBefore(pullquoteMarkup, paragraph);
      }
      paragraph.remove();
    });
  }

  function removeEmptyArticleParagraphs(root) {
    var content = root.querySelector('[data-article-v2-content]');
    if (!content) return;

    function trimTrailingBreakPlaceholders(node) {
      while (node.lastChild) {
        var lastChild = node.lastChild;
        var isWhitespaceText = lastChild.nodeType === 3 && !(lastChild.textContent || '')
          .replace(/[\u200B-\u200D\u2060\uFEFF\u00A0\s]/g, '');
        if (isWhitespaceText || (lastChild.nodeType === 1 && lastChild.tagName === 'BR')) {
          lastChild.remove();
          continue;
        }
        break;
      }
    }

    /* Shopify's rich-text editor can serialize a trailing line break inside
     * a heading or paragraph, or a standalone break between two block nodes.
     * Those breaks are editing placeholders rather than intentional article
     * spacing. Keep interior breaks (for example a two-line title) intact. */
    Array.prototype.forEach.call(content.querySelectorAll('h1, h2, h3, h4, h5, h6'), function (heading) {
      trimTrailingBreakPlaceholders(heading);
    });

    Array.prototype.forEach.call(content.children, function (node) {
      if (node.tagName === 'BR') {
        node.remove();
        return;
      }
      if (node.tagName !== 'P') return;
      trimTrailingBreakPlaceholders(node);
      var text = (node.textContent || '')
        .replace(/[\u200B-\u200D\u2060\uFEFF\u00A0\s]/g, '');
      var meaningfulChild = node.querySelector(':not(br)');
      if (!text && !meaningfulChild) node.remove();
    });
  }

  function trimTrailingEmptyVerdictParagraphs(root) {
    Array.prototype.forEach.call(
      root.querySelectorAll('.sa-article-v2-verdict__item-description'),
      function (description) {
        var emptyNodes = Array.prototype.slice.call(description.querySelectorAll('p, br, div')).reverse();
        emptyNodes.forEach(function (node) {
          if (node === description) return;
          var text = (node.textContent || '')
            .replace(/[\u200B-\u200D\u2060\uFEFF\u00A0\s]/g, '');
          var meaningfulChild = node.querySelector('img, video, iframe, a, strong, em, b, i, code, ul, ol, table');
          if (!text && !meaningfulChild) node.remove();
        });

        while (description.lastChild && description.lastChild.nodeType === 3 && !description.lastChild.textContent.trim()) {
          description.lastChild.remove();
        }

        var paragraphs = Array.prototype.slice.call(description.querySelectorAll('p')).reverse();
        paragraphs.some(function (paragraph) {
          var text = (paragraph.textContent || '')
            .replace(/[\u200B-\u200D\u2060\uFEFF\u00A0\s]/g, '');
          if (!text) return false;
          while (paragraph.lastChild) {
            var lastChild = paragraph.lastChild;
            if (lastChild.nodeType === 3 && !lastChild.textContent.trim()) {
              lastChild.remove();
              continue;
            }
            if (lastChild.nodeType === 1 && lastChild.tagName === 'BR') {
              lastChild.remove();
              continue;
            }
            break;
          }
          return true;
        });
      }
    );
  }

  function registerCleanup(root, cleanup) {
    if (!root.__articleV2Cleanup) root.__articleV2Cleanup = [];
    root.__articleV2Cleanup.push(cleanup);
  }

  function destroyRoot(root) {
    if (!root) return;
    var cleanup = root.__articleV2Cleanup || [];
    cleanup.splice(0).reverse().forEach(function (dispose) {
      try {
        dispose();
      } catch (error) {
        // The section can already be detached while the editor unloads it.
      }
    });
    delete root.__articleV2Cleanup;
    delete root.__articleV2TocUpdate;
    delete root.__articleV2RailResize;
    delete root.__articleV2Swipers;
    delete root.__articleV2Swiper;
    Array.prototype.forEach.call(root.querySelectorAll('[data-article-v2-toc-scroll]'), function (scroll) {
      delete scroll.dataset.articleV2TocScrollbarInitialized;
      delete scroll.__articleV2TocScrollbarUpdate;
    });
    Array.prototype.forEach.call(root.querySelectorAll('.sa-article-v2__product-swiper'), function (carousel) {
      delete carousel.dataset.articleV2SwiperInitialized;
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-article-v2-generated]'), function (node) {
      node.remove();
    });
    root.removeAttribute('data-article-v2-initialized');
  }

  function initTocScrollbars(root) {
    var toc = root.querySelector('[data-article-v2-toc]');
    var scroll = root.querySelector('[data-article-v2-toc-scroll]');
    if (!toc || !scroll) return;
    if (scroll.dataset.articleV2TocScrollbarInitialized === 'true') {
      if (typeof scroll.__articleV2TocScrollbarUpdate === 'function') scroll.__articleV2TocScrollbarUpdate();
      return;
    }

    var tracks = [
      { element: toc.querySelector('.sa-article-v2__toc-scrollbar--vertical'), orientation: 'vertical' },
      { element: toc.querySelector('.sa-article-v2__toc-scrollbar--horizontal'), orientation: 'horizontal' }
    ];
    var updates = [];

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    tracks.forEach(function (entry) {
      var track = entry.element;
      if (!track) return;
      var thumb = track.querySelector('span');
      if (!thumb) return;
      var dragging = false;

      function update() {
        var isVerticalTrack = entry.orientation === 'vertical';
        var viewport = isVerticalTrack ? scroll.clientHeight : scroll.clientWidth;
        var contentSize = isVerticalTrack ? scroll.scrollHeight : scroll.scrollWidth;
        var scrollPosition = isVerticalTrack ? scroll.scrollTop : scroll.scrollLeft;
        var maxScroll = Math.max(contentSize - viewport, 0);
        var trackSize = isVerticalTrack ? track.clientHeight : track.clientWidth;
        var thumbSize = contentSize > 0 ? Math.min(viewport / contentSize, 1) * 100 : 100;
        var thumbPosition = maxScroll > 0
          ? scrollPosition / maxScroll * (100 - thumbSize)
          : 0;

        track.dataset.scrollable = maxScroll > 1 ? 'true' : 'false';
        track.style.setProperty('--sa-article-v2-toc-scrollbar-thumb-size', Math.max(thumbSize, trackSize ? 12 / trackSize * 100 : 0) + '%');
        track.style.setProperty('--sa-article-v2-toc-scrollbar-thumb-position', thumbPosition + '%');
      }

      function moveFromPointer(clientPosition) {
        if (track.dataset.scrollable !== 'true') return;
        var isVerticalTrack = entry.orientation === 'vertical';
        var bounds = track.getBoundingClientRect();
        var trackSize = isVerticalTrack ? bounds.height : bounds.width;
        var thumbSize = parseFloat(getComputedStyle(thumb)[isVerticalTrack ? 'height' : 'width']) || 0;
        var available = Math.max(trackSize - thumbSize, 0);
        var start = isVerticalTrack ? bounds.top : bounds.left;
        var position = clientPosition - start - thumbSize / 2;
        var ratio = available > 0 ? clamp(position / available, 0, 1) : 0;
        if (isVerticalTrack) {
          scroll.scrollTop = ratio * (scroll.scrollHeight - scroll.clientHeight);
        } else {
          scroll.scrollLeft = ratio * (scroll.scrollWidth - scroll.clientWidth);
        }
      }

      function handlePointerDown(event) {
        if (track.dataset.scrollable !== 'true') return;
        dragging = true;
        track.setPointerCapture(event.pointerId);
        moveFromPointer(entry.orientation === 'vertical' ? event.clientY : event.clientX);
        event.preventDefault();
      }
      function handlePointerMove(event) {
        if (!dragging) return;
        moveFromPointer(entry.orientation === 'vertical' ? event.clientY : event.clientX);
      }
      function stopDragging(event) {
        if (!dragging) return;
        dragging = false;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      }
      track.addEventListener('pointerdown', handlePointerDown);
      track.addEventListener('pointermove', handlePointerMove);
      track.addEventListener('pointerup', stopDragging);
      track.addEventListener('pointercancel', stopDragging);
      scroll.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      var resizeObserver;
      if (window.ResizeObserver) {
        resizeObserver = new window.ResizeObserver(update);
        resizeObserver.observe(scroll);
        resizeObserver.observe(toc);
      }
      registerCleanup(root, function () {
        track.removeEventListener('pointerdown', handlePointerDown);
        track.removeEventListener('pointermove', handlePointerMove);
        track.removeEventListener('pointerup', stopDragging);
        track.removeEventListener('pointercancel', stopDragging);
        scroll.removeEventListener('scroll', update);
        window.removeEventListener('resize', update);
        if (resizeObserver) resizeObserver.disconnect();
      });
      updates.push(update);
      update();
    });
    scroll.__articleV2TocScrollbarUpdate = function () {
      updates.forEach(function (update) { update(); });
    };
    scroll.dataset.articleV2TocScrollbarInitialized = 'true';
  }

  function createToc(root) {
    var content = root.querySelector('[data-article-v2-content]');
    var toc = root.querySelector('[data-article-v2-toc]');
    var list = root.querySelector('[data-article-v2-toc-list]');
    if (!content || !toc || !list) return;
    if (list.children.length) {
      toc.hidden = false;
      return;
    }

    /*
     * The article body contains headings from several nested modules. Only
     * the article-level section headings belong in the TOC. In particular,
     * product review titles and key-point card headings are content inside a
     * section rather than navigation sections themselves. The key-point
     * section heading is the exception: it is an article-level heading and is
     * kept alongside Conclusion and FAQ in the rendered article order.
     */
    var headings = Array.prototype.slice.call(root.querySelectorAll('h1, h2, h3, h4, h5, h6')).filter(function (heading) {
      if (heading.matches('.sa-article-v2__title')) {
        return false;
      }

      if (heading.closest('.sa-article-v2__toc, .sa-article-v2-review, .sa-article-v2__faq-list, .sa-article-v2__author-card, .sa-article-v2__product-rail, .sa-article-v2-related')) {
        return false;
      }

      if (heading.closest('.sa-article-v2-verdict') &&
          !heading.matches('.sa-article-v2-verdict__section-heading')) {
        return false;
      }

      /* Keep subordinate headings out unless their rendered size is a title. */
      var headingLevel = Number(heading.tagName.slice(1));
      if (headingLevel > 2) {
        var headingFontSize = parseFloat(window.getComputedStyle(heading).fontSize);
        if (!Number.isFinite(headingFontSize) || headingFontSize < 32) return false;
      }

      return true;
    });

    /*
     * The introductory copy is intentionally title-less in the article body,
     * but it is a first-class section in the Figma TOC. Reuse its first
     * top-level content node as the navigation anchor instead of adding a
     * visible heading to the article.
     */
    var hasIntroductionHeading = headings.some(function (heading) {
      return heading.textContent.trim().toLowerCase() === 'introduction';
    });
    var introductionLabel = (content.dataset.articleV2IntroductionLabel || '').trim();
    if (!hasIntroductionHeading && introductionLabel) {
      var firstHeading = headings[0] || null;
      var topLevelChildren = Array.prototype.slice.call(content.children);
      var firstHeadingIndex = firstHeading ? topLevelChildren.indexOf(firstHeading) : topLevelChildren.length;

      if (firstHeading && firstHeadingIndex < 0) {
        firstHeadingIndex = topLevelChildren.findIndex(function (child) {
          return child.contains(firstHeading);
        });
      }

      var introductionAnchor = topLevelChildren.slice(0, firstHeadingIndex < 0 ? topLevelChildren.length : firstHeadingIndex).find(function (child) {
        return child.textContent.trim() !== '';
      });

      if (introductionAnchor) {
        if (!introductionAnchor.id) introductionAnchor.id = slugify(introductionLabel, 0);
        introductionAnchor.setAttribute('data-article-v2-toc-label', introductionLabel);
        headings.unshift(introductionAnchor);
      }
    }

    if (!headings.length) {
      toc.hidden = true;
      return;
    }
    toc.hidden = false;

    var toggle = toc.querySelector('[data-article-v2-toc-toggle]');
    var panel = toc.querySelector('[data-article-v2-toc-panel]');
    if (toggle && panel) {
      function setTocExpanded(isExpanded) {
        toc.dataset.tocExpanded = isExpanded ? 'true' : 'false';
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        panel.hidden = !isExpanded;
      }

      function handleToggleClick() {
        setTocExpanded(toggle.getAttribute('aria-expanded') !== 'true');
      }
      toggle.addEventListener('click', handleToggleClick);
      registerCleanup(root, function () {
        toggle.removeEventListener('click', handleToggleClick);
      });
      setTocExpanded(toc.dataset.tocExpanded !== 'false');
    }

    var ids = Object.create(null);
    headings.forEach(function (heading, index) {
      var base = heading.id || slugify(heading.textContent, index + 1);
      var id = base;
      var count = 1;
      while (document.getElementById(id) && document.getElementById(id) !== heading) {
        id = base + '-' + count;
        count += 1;
      }
      ids[id] = true;
      heading.id = id;

      var item = document.createElement('li');
      item.setAttribute('data-article-v2-generated', 'true');
      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.getAttribute('data-article-v2-toc-label') || heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });

    var links = Array.prototype.slice.call(list.querySelectorAll('a'));
    var items = Array.prototype.slice.call(list.querySelectorAll('li'));
    var pendingNavigationId = null;
    var pendingNavigationTimer = null;

    function setActiveHeading(id) {
      var activeIndex = links.findIndex(function (link) {
        return link.getAttribute('href') === '#' + id;
      });
      links.forEach(function (link, index) {
        var isActive = index === activeIndex;
        var isComplete = activeIndex > index;
        link.classList.toggle('is-active', isActive);
        items[index].classList.toggle('is-active', isActive);
        items[index].classList.toggle('is-complete', isComplete);
        if (isActive) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function getHeadingById(id) {
      return headings.find(function (heading) {
        return heading.id === id;
      });
    }

    function clearPendingNavigation() {
      pendingNavigationId = null;
      if (pendingNavigationTimer !== null) {
        window.clearTimeout(pendingNavigationTimer);
        pendingNavigationTimer = null;
      }
    }

    function schedulePendingNavigationRelease(delay) {
      if (!pendingNavigationId) return;
      if (pendingNavigationTimer !== null) window.clearTimeout(pendingNavigationTimer);
      pendingNavigationTimer = window.setTimeout(function () {
        clearPendingNavigation();
        requestActiveHeadingUpdate();
      }, delay);
    }

    function startPendingNavigation(id) {
      clearPendingNavigation();
      pendingNavigationId = id;
      /* A safety release for browsers that do not emit `scrollend`. The
       * clicked item otherwise stays locked until the target actually reaches
       * the article activation offset. */
      schedulePendingNavigationRelease(2000);
    }

    function getActivationOffset() {
      var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--height-header')) || 0;
      return headerHeight + 24;
    }

    function isPendingNavigationSettled() {
      var pendingHeading = pendingNavigationId ? getHeadingById(pendingNavigationId) : null;
      if (!pendingHeading) return true;

      var targetTop = pendingHeading.getBoundingClientRect().top;
      var activationOffset = getActivationOffset();
      var maxScrollY = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
      var atPageStart = window.scrollY <= 1;
      var atPageEnd = window.scrollY >= maxScrollY - 1;

      return Math.abs(targetTop - activationOffset) <= 4 || atPageStart || atPageEnd;
    }

    var linkHandlers = [];
    links.forEach(function (link) {
      function handleLinkClick(event) {
        var targetId = link.getAttribute('href').slice(1);
        var targetHeading = getHeadingById(targetId);
        if (!targetHeading) return;

        event.preventDefault();
        startPendingNavigation(targetId);
        setActiveHeading(targetId);

        if (window.history && typeof window.history.pushState === 'function') {
          window.history.pushState(null, '', '#' + targetId);
        } else {
          window.location.hash = targetId;
        }

        targetHeading.scrollIntoView({
          block: 'start',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        window.requestAnimationFrame(function () {
          if (pendingNavigationId !== targetId || !isPendingNavigationSettled()) return;
          clearPendingNavigation();
          requestActiveHeadingUpdate();
        });
        requestActiveHeadingUpdate();
      }
      link.addEventListener('click', handleLinkClick);
      linkHandlers.push({ link: link, handler: handleLinkClick });
    });
    var initialHeading = window.location.hash ? window.location.hash.slice(1) : headings[0].id;
    if (!list.querySelector('[href="#' + initialHeading + '"]')) {
      initialHeading = headings[0].id;
    }
    setActiveHeading(initialHeading);
    var ticking = false;
    function updateActiveHeading() {
      var activationOffset = getActivationOffset();
      var activationPosition = window.scrollY + activationOffset;
      var contentBottom = content.getBoundingClientRect().bottom + window.scrollY;
      var activeHeading = headings[0];

      var positionedHeadings = headings.map(function (heading, index) {
        return {
          heading: heading,
          index: index,
          top: heading.getBoundingClientRect().top + window.scrollY
        };
      }).sort(function (first, second) {
        return first.top - second.top;
      });

      positionedHeadings.forEach(function (entry, index) {
        var headingTop = entry.top;
        var nextHeading = positionedHeadings[index + 1];
        var sectionBottom = nextHeading ? nextHeading.top : contentBottom;
        var sectionHeight = Math.max(sectionBottom - headingTop, 1);
        var progress = Math.max(0, Math.min(1, (activationPosition - headingTop) / sectionHeight));

        items[entry.index].style.setProperty('--sa-article-v2-toc-ruler-progress', Math.round(progress * 100) + '%');
        if (entry.top <= activationPosition) {
          activeHeading = entry.heading;
        }
      });

      var pendingHeading = pendingNavigationId ? getHeadingById(pendingNavigationId) : null;
      if (pendingHeading) {
        /* Keep the clicked item active for the entire programmatic scroll.
         * This prevents upward jumps from flashing through every heading the
         * viewport passes before reaching the requested destination. */
        activeHeading = pendingHeading;
      }
      setActiveHeading(activeHeading.id);
      ticking = false;
    }
    var activeHeadingFrame = null;
    function requestActiveHeadingUpdate() {
      if (ticking) return;
      ticking = true;
      activeHeadingFrame = window.requestAnimationFrame(updateActiveHeading);
    }

    function handleTocScroll() {
      requestActiveHeadingUpdate();
    }

    function handleTocScrollEnd() {
      if (!pendingNavigationId) return;
      if (!isPendingNavigationSettled()) return;
      clearPendingNavigation();
      requestActiveHeadingUpdate();
    }
    function handleTocResize() {
      requestActiveHeadingUpdate();
    }

    window.addEventListener('scroll', handleTocScroll, { passive: true });
    window.addEventListener('scrollend', handleTocScrollEnd, { passive: true });
    window.addEventListener('resize', handleTocResize);
    registerCleanup(root, function () {
      window.removeEventListener('scroll', handleTocScroll);
      window.removeEventListener('scrollend', handleTocScrollEnd);
      window.removeEventListener('resize', handleTocResize);
      if (activeHeadingFrame !== null) window.cancelAnimationFrame(activeHeadingFrame);
      clearPendingNavigation();
      linkHandlers.forEach(function (entry) {
        entry.link.removeEventListener('click', entry.handler);
      });
    });
    requestActiveHeadingUpdate();
    root.__articleV2TocUpdate = requestActiveHeadingUpdate;
  }

  function groupConclusion(root) {
    var content = root.querySelector('[data-article-v2-content]');
    if (!content || content.querySelector('.sa-article-v2__conclusion')) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    var conclusionHeading = headings.find(function (heading) {
      if (heading.classList.contains('sa-article-v2__faq-title')) return false;

      var headingId = (heading.id || '').trim().toLowerCase();
      var sectionId = (heading.getAttribute('data-section-id') || '').trim().toLowerCase();
      var headingText = heading.textContent.trim().toLowerCase();
      return headingId === 'conclusion' || sectionId === 'conclusion' || headingText === 'conclusion';
    });
    if (!conclusionHeading) return;

    var conclusion = document.createElement('section');
    var body = document.createElement('div');
    var headingParent = conclusionHeading.parentElement;
    var sibling = conclusionHeading.nextElementSibling;
    var headingId = conclusionHeading.id || 'sa-article-v2-conclusion-' + (root.dataset.sectionId || 'section');

    conclusion.className = 'sa-article-v2__conclusion';
    conclusion.setAttribute('aria-labelledby', headingId);
    body.className = 'sa-article-v2__conclusion-body';
    conclusionHeading.id = headingId;
    conclusionHeading.classList.add('sa-article-v2__conclusion-title');

    headingParent.insertBefore(conclusion, conclusionHeading);
    conclusion.appendChild(conclusionHeading);
    conclusion.appendChild(body);

    while (sibling && sibling.tagName === 'P') {
      var nextSibling = sibling.nextElementSibling;
      body.appendChild(sibling);
      sibling = nextSibling;
    }

    if (!body.children.length) body.remove();
  }

  function applyImageStyles(root) {
    var content = root.querySelector('[data-article-v2-content]');
    var styles = [];
    var serializedStyles = root.getAttribute('data-article-v2-image-styles');

    if (serializedStyles) {
      try {
        var parsedStyles = JSON.parse(serializedStyles);
        if (Array.isArray(parsedStyles)) styles = parsedStyles;
      } catch (error) {
        /* Invalid or legacy values fall through to the previous global bridge. */
      }
    }
    if (!styles.length && Array.isArray(window.articleV2ImageStyle)) {
      styles = window.articleV2ImageStyle;
    }
    if (!content || !styles.length) return;
    if (typeof root.__articleV2ApplyImageStyles === 'function') {
      root.__articleV2ApplyImageStyles();
      return;
    }

    function normalizeImageHeight(style) {
      var rawHeight = style;

      if (style && typeof style === 'object') {
        rawHeight = style.height || style.image_height || style.desktop_height || style.max_height;
      }
      if (typeof rawHeight === 'number' && Number.isFinite(rawHeight) && rawHeight > 0) {
        return rawHeight + 'px';
      }
      if (typeof rawHeight !== 'string') return '';

      var value = rawHeight.trim();
      if (/^\d+(?:\.\d+)?$/.test(value)) value += 'px';
      if (!/^\d+(?:\.\d+)?(?:px|rem|em|vh|vw|vmin|vmax|%)$/i.test(value)) return '';
      return value;
    }

    function getConfigurableImages() {
      return Array.prototype.slice.call(content.querySelectorAll('img')).filter(function (image) {
        if (image.classList.contains('sa-article-v2-review__image')) return true;

        return !image.closest(
          '.sa-article-v2-product, ' +
          '.sa-article-v2__author-card, ' +
          '.sa-article-v2-review__callout-icon, ' +
          '.sa-article-v2-callout__heading, ' +
          '.sa-article-notices__badge, ' +
          '.sa-article-pros-cons__badge'
        );
      });
    }

    function applyStyle(image) {
      if (window.innerWidth < 1280) return;

      var images = getConfigurableImages();
      var index = images.indexOf(image);
      if (index < 0 || !styles[index]) return;

      var height = normalizeImageHeight(styles[index]);
      if (!height) return;

      var reviewMedia = image.closest('.sa-article-v2-review__media');
      var reviewFrame = image.closest('.sa-article-v2-review__media-frame');
      if (reviewMedia && reviewFrame) {
        reviewMedia.setAttribute('data-configured-height', 'true');
        reviewFrame.style.setProperty('--sa-article-v2-review-image-height', height);
        return;
      }

      image.setAttribute('data-article-v2-configured-height', 'true');
      image.style.setProperty('--sa-article-v2-content-image-max-height', height);
    }

    function applyConfiguredImages() {
      if (window.innerWidth < 1280) return;
      Array.prototype.forEach.call(content.querySelectorAll('img'), applyStyle);
    }

    root.__articleV2ApplyImageStyles = applyConfiguredImages;
    applyConfiguredImages();

    var wasDesktop = window.innerWidth >= 1280;
    var handleImageStyleResize = function () {
      var isDesktop = window.innerWidth >= 1280;
      if (isDesktop && !wasDesktop) applyConfiguredImages();
      wasDesktop = isDesktop;
    };
    window.addEventListener('resize', handleImageStyleResize, { passive: true });

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') {
            applyStyle(node);
            return;
          }
          Array.prototype.forEach.call(node.querySelectorAll('img'), applyStyle);
        });
        if (mutation.type === 'attributes' && mutation.target.tagName === 'IMG') {
          applyStyle(mutation.target);
        }
      });
    });
    observer.observe(content, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'src', 'srcset', 'data-src']
    });
    root.__articleV2ImageObserver = observer;
    registerCleanup(root, function () {
      observer.disconnect();
      window.removeEventListener('resize', handleImageStyleResize);
      delete root.__articleV2ImageObserver;
      delete root.__articleV2ApplyImageStyles;
    });
  }

  function wrapTables(root) {
    var content = root.querySelector('[data-article-v2-content]');
    if (!content) return;

    Array.prototype.forEach.call(content.querySelectorAll('table'), function (table) {
      if (table.closest('.sa-article-v2-comparison-table__scroll')) return;
      if (table.parentElement && table.parentElement.classList.contains('article-table')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'article-table';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      if (content.dataset.tableScrollLabel) wrapper.setAttribute('aria-label', content.dataset.tableScrollLabel);
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  function removeEmptyComparisonRows(root) {
    var rows = root.querySelectorAll('.sa-article-v2-comparison-table__table tbody tr');
    Array.prototype.forEach.call(rows, function (row) {
      var visibleText = row.textContent.replace(/[\s\u00a0\u200b]+/g, '');
      if (!visibleText) row.remove();
    });
  }

  function initComparisonTableScrollbars(root) {
    var comparisonGroups = root.querySelectorAll('.sa-article-v2-comparison-table__table-group');

    Array.prototype.forEach.call(comparisonGroups, function (group) {
      var scroll = group.querySelector('.sa-article-v2-comparison-table__scroll');
      var scrollbar = group.querySelector('[data-comparison-scrollbar]');
      if (!scroll || !scrollbar) return;

      var isDragging = false;

      function clamp(value, minimum, maximum) {
        return Math.min(Math.max(value, minimum), maximum);
      }

      function getMeasurements() {
        var maxScroll = Math.max(scroll.scrollWidth - scroll.clientWidth, 0);
        var thumbRatio = scroll.scrollWidth ? Math.min(scroll.clientWidth / scroll.scrollWidth, 1) : 1;
        return {
          maxScroll: maxScroll,
          thumbRatio: thumbRatio
        };
      }

      function updateScrollbar() {
        var measurements = getMeasurements();
        var isScrollable = measurements.maxScroll > 1;
        var scrollRatio = isScrollable ? clamp(scroll.scrollLeft / measurements.maxScroll, 0, 1) : 0;
        var thumbSize = measurements.thumbRatio * 100;
        var thumbPosition = scrollRatio * (100 - thumbSize);

        scrollbar.dataset.scrollable = isScrollable ? 'true' : 'false';
        scrollbar.tabIndex = isScrollable ? 0 : -1;
        scrollbar.setAttribute('aria-valuenow', String(Math.round(scrollRatio * 100)));
        scrollbar.setAttribute('aria-disabled', isScrollable ? 'false' : 'true');
        scrollbar.style.setProperty('--sa-article-v2-comparison-scrollbar-thumb-size', thumbSize + '%');
        scrollbar.style.setProperty('--sa-article-v2-comparison-scrollbar-position', thumbPosition + '%');
      }

      function moveScrollFromPointer(clientX) {
        var measurements = getMeasurements();
        if (measurements.maxScroll <= 1) return;

        var bounds = scrollbar.getBoundingClientRect();
        var thumbWidth = bounds.width * measurements.thumbRatio;
        var availableTrack = bounds.width - thumbWidth;
        var pointerPosition = clientX - bounds.left - (thumbWidth / 2);
        var scrollRatio = availableTrack > 0 ? clamp(pointerPosition / availableTrack, 0, 1) : 0;
        scroll.scrollLeft = scrollRatio * measurements.maxScroll;
      }

      function handlePointerDown(event) {
        if (scrollbar.dataset.scrollable !== 'true') return;
        isDragging = true;
        scrollbar.setPointerCapture(event.pointerId);
        moveScrollFromPointer(event.clientX);
        event.preventDefault();
      }

      function handlePointerMove(event) {
        if (!isDragging) return;
        moveScrollFromPointer(event.clientX);
      }

      function stopDragging(event) {
        if (!isDragging) return;
        isDragging = false;
        if (scrollbar.hasPointerCapture(event.pointerId)) scrollbar.releasePointerCapture(event.pointerId);
      }

      function handleKeydown(event) {
        var measurements = getMeasurements();
        if (measurements.maxScroll <= 1) return;

        var scrollStep = Math.max(scroll.clientWidth * 0.8, 1);
        var nextScroll = scroll.scrollLeft;
        if (event.key === 'ArrowLeft') nextScroll -= scrollStep;
        else if (event.key === 'ArrowRight') nextScroll += scrollStep;
        else if (event.key === 'Home') nextScroll = 0;
        else if (event.key === 'End') nextScroll = measurements.maxScroll;
        else return;

        scroll.scrollLeft = clamp(nextScroll, 0, measurements.maxScroll);
        event.preventDefault();
      }

      scrollbar.addEventListener('pointerdown', handlePointerDown);
      scrollbar.addEventListener('pointermove', handlePointerMove);
      scrollbar.addEventListener('pointerup', stopDragging);
      scrollbar.addEventListener('pointercancel', stopDragging);
      scrollbar.addEventListener('keydown', handleKeydown);
      scroll.addEventListener('scroll', updateScrollbar, { passive: true });
      window.addEventListener('resize', updateScrollbar, { passive: true });
      var resizeObserver;
      if (window.ResizeObserver) {
        resizeObserver = new window.ResizeObserver(updateScrollbar);
        resizeObserver.observe(scroll);
      }
      registerCleanup(root, function () {
        scrollbar.removeEventListener('pointerdown', handlePointerDown);
        scrollbar.removeEventListener('pointermove', handlePointerMove);
        scrollbar.removeEventListener('pointerup', stopDragging);
        scrollbar.removeEventListener('pointercancel', stopDragging);
        scrollbar.removeEventListener('keydown', handleKeydown);
        scroll.removeEventListener('scroll', updateScrollbar);
        window.removeEventListener('resize', updateScrollbar);
        if (resizeObserver) resizeObserver.disconnect();
      });
      window.requestAnimationFrame(updateScrollbar);
    });
  }

  function initProductRail(root) {
    if (typeof window.Swiper !== 'function') return;
    var swipers = root.__articleV2Swipers || [];
    Array.prototype.forEach.call(root.querySelectorAll('.sa-article-v2__product-swiper'), function (carousel) {
      var productCarousel = carousel.closest('.sa-article-v2__product-carousel');
      if (carousel.dataset.articleV2SwiperInitialized === 'true') return;
      if (!carousel.getClientRects().length) return;

      var slides = carousel.querySelectorAll('.swiper-slide');
      var controlsWrap = productCarousel && productCarousel.querySelector('[data-product-controls-wrap]');
      var pause = productCarousel && productCarousel.querySelector('[data-product-pause]');
      var controlGroup = productCarousel && productCarousel.querySelector('.sa-article-v2__product-controls .cs-section-swiper');
      var previous = productCarousel && productCarousel.querySelector('.swiper-button-prev');
      var pagination = productCarousel && productCarousel.querySelector('.swiper-pagination');
      var autoplayEnabled = carousel.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (pause && !autoplayEnabled) {
        pause.hidden = true;
        pause.disabled = true;
        pause.setAttribute('aria-hidden', 'true');
        pause.setAttribute('aria-pressed', 'false');
      }

      if (controlGroup && pagination && previous) {
        controlGroup.insertBefore(pagination, controlGroup.firstChild);
        if (pause) controlGroup.insertBefore(pause, previous);
      }

      if (slides.length <= 1) {
        if (controlsWrap) controlsWrap.hidden = true;
        carousel.dataset.articleV2SwiperInitialized = 'true';
        return;
      }

      var swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: true,
        loop: true,
        rewind: false,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        navigation: {
          prevEl: productCarousel && productCarousel.querySelector('.swiper-button-prev'),
          nextEl: productCarousel && productCarousel.querySelector('.swiper-button-next')
        },
        autoplay: autoplayEnabled
          ? { delay: Number(carousel.dataset.delay) || 5000, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false
      };
      if (pagination) {
        swiperOptions.pagination = {
          el: pagination,
          type: 'bullets'
        };
      }
      var swiper = new window.Swiper(carousel, swiperOptions);
      swipers.push(swiper);
      carousel.dataset.articleV2SwiperInitialized = 'true';

      var focusInsideProduct = false;
      var handleProductFocusIn = null;
      var handleProductFocusOut = null;
      if (productCarousel && autoplayEnabled && swiper.autoplay) {
        var pauseProductAutoplay = function () {
          if (!swiper.destroyed && !swiper.autoplay.paused) swiper.autoplay.pause();
        };
        var resumeProductAutoplay = function () {
          var manuallyPaused = pause && pause.getAttribute('aria-pressed') === 'true';
          var mouseInsideProduct = productCarousel.matches(':hover');
          if (!swiper.destroyed && !mouseInsideProduct && !focusInsideProduct && !manuallyPaused && swiper.autoplay.paused) {
            swiper.autoplay.resume();
          }
        };
        handleProductFocusIn = function (event) {
          focusInsideProduct = !!(event.target && event.target.matches && event.target.matches(':focus-visible'));
          if (focusInsideProduct) pauseProductAutoplay();
        };
        handleProductFocusOut = function (event) {
          if (event.relatedTarget && productCarousel.contains(event.relatedTarget)) return;
          focusInsideProduct = false;
          resumeProductAutoplay();
        };
        productCarousel.addEventListener('focusin', handleProductFocusIn);
        productCarousel.addEventListener('focusout', handleProductFocusOut);
      }

      if (pagination && autoplayEnabled && swiper.autoplay) {
        var syncProductProgress = function (instance, timeLeft, progress) {
          pagination.style.setProperty('--cs-section-swiper-progress', ((1 - progress) * 100) + '%');
        };
        var resetProductProgress = function () {
          pagination.style.setProperty('--cs-section-swiper-progress', '0%');
        };
        swiper.on('autoplayTimeLeft', syncProductProgress);
        swiper.on('slideChangeTransitionStart', resetProductProgress);
      }

      window.requestAnimationFrame(function () {
        if (swiper.destroyed) return;
        swiper.update();
        swiper.updateAutoHeight(0);
      });

      var handlePauseClick = null;
      if (pause && autoplayEnabled && swiper.autoplay) {
        var pauseLabel = pause.getAttribute('data-pause-label');
        var playLabel = pause.getAttribute('data-play-label');
        var pauseText = pause.querySelector('[data-product-pause-label]');
        var syncPauseState = function (isPaused) {
          pause.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
          pause.setAttribute('aria-label', isPaused ? playLabel : pauseLabel);
          if (pauseText) pauseText.textContent = isPaused ? playLabel : pauseLabel;
        };
        handlePauseClick = function () {
          if (swiper.autoplay.paused) {
            swiper.autoplay.resume();
            syncPauseState(false);
          } else {
            swiper.autoplay.pause();
            syncPauseState(true);
          }
        };
        pause.addEventListener('click', handlePauseClick);
      } else if (pause) {
        pause.hidden = true;
      }
      registerCleanup(root, function () {
        if (productCarousel && handleProductFocusIn) productCarousel.removeEventListener('focusin', handleProductFocusIn);
        if (productCarousel && handleProductFocusOut) productCarousel.removeEventListener('focusout', handleProductFocusOut);
        if (pause && handlePauseClick) pause.removeEventListener('click', handlePauseClick);
        if (!swiper.destroyed) swiper.destroy(true, true);
      });
    });
    root.__articleV2Swipers = swipers;
    root.__articleV2Swiper = swipers[0] || null;

    if (!root.__articleV2RailResize) {
      root.__articleV2RailResize = function () {
        initProductRail(root);
      };
      window.addEventListener('resize', root.__articleV2RailResize);
      registerCleanup(root, function () {
        window.removeEventListener('resize', root.__articleV2RailResize);
      });
    }
  }

  function initFaq(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-article-v2-faq-item]'), function (item) {
      if (item.dataset.articleV2FaqInitialized === 'true') return;

      var trigger = item.querySelector('[data-article-v2-faq-trigger]');
      var answerId = trigger && trigger.getAttribute('aria-controls');
      var content = answerId ? root.querySelector('#' + answerId) : null;
      if (!trigger || !content) return;

      var handleClick = function () {
        var expanded = !item.classList.contains('active');
        if (typeof window.slideAnime === 'function') {
          window.slideAnime({ target: content, animeType: 'slideToggle' });
        } else {
          content.style.display = expanded ? 'block' : 'none';
        }
        item.classList.toggle('active', expanded);
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };

      trigger.addEventListener('click', handleClick);
      item.dataset.articleV2FaqInitialized = 'true';
      registerCleanup(root, function () {
        trigger.removeEventListener('click', handleClick);
        delete item.dataset.articleV2FaqInitialized;
      });
    });
  }

  function initRoot(root) {
    if (!root) return;
    if (root.dataset.articleV2Initialized === 'true') {
      hydratePullquotes(root);
      removeEmptyArticleParagraphs(root);
      groupConclusion(root);
      createToc(root);
      initTocScrollbars(root);
      applyImageStyles(root);
      initFaq(root);
      initProductRail(root);
      return;
    }
    root.dataset.articleV2Initialized = 'true';
    root.__articleV2Cleanup = [];
    trimTrailingEmptyVerdictParagraphs(root);
    hydratePullquotes(root);
    removeEmptyArticleParagraphs(root);
    wrapTables(root);
    removeEmptyComparisonRows(root);
    initComparisonTableScrollbars(root);
    groupConclusion(root);
    createToc(root);
    initTocScrollbars(root);
    applyImageStyles(root);
    initFaq(root);
    initProductRail(root);
  }

  function init() {
    document.querySelectorAll('.sa-article-v2-section').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  window.addEventListener('load', init, { once: true });

  function findSectionRoot(target) {
    return target && target.matches && target.matches('.sa-article-v2-section')
      ? target
      : target && target.querySelector
        ? target.querySelector('.sa-article-v2-section')
        : null;
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = findSectionRoot(event.target);
    initRoot(sectionRoot);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyRoot(findSectionRoot(event.target));
  });
}());
